module.exports = __webpack_public_path__ + "de3db4ee1488ec2e8c3652541f275b7e.png";